/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CustomerEntity } from '../models/CustomerEntity';
import type { GuestEntity } from '../models/GuestEntity';
import type { MultipassEntity } from '../models/MultipassEntity';
import type { OrderEntity } from '../models/OrderEntity';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class CustomerService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get Customers
     * @returns CustomerEntity The Customers have been returned
     * @throws ApiError
     */
    public customerControllerGetCustomersV1(): CancelablePromise<Array<CustomerEntity>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/customer',
        });
    }
    /**
     * Get a Customer
     * @param customerId
     * @param xInstructorIndicator Indicator to scope the request to the instructor
     * @returns CustomerEntity The Customer has been returned
     * @throws ApiError
     */
    public customerControllerGetCustomerV1(
        customerId: string,
        xInstructorIndicator: string | null = 'true',
    ): CancelablePromise<CustomerEntity> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/customer/{customerId}',
            path: {
                'customerId': customerId,
            },
            headers: {
                'x-instructor-indicator': xInstructorIndicator,
            },
            errors: {
                404: `The Customer has not been found`,
            },
        });
    }
    /**
     * Get Customer Orders
     * @param customerId
     * @returns OrderEntity The Customer Orders have been returned
     * @throws ApiError
     */
    public customerControllerGetCustomerOrdersV1(
        customerId: string,
    ): CancelablePromise<Array<OrderEntity>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/customer/{customerId}/orders',
            path: {
                'customerId': customerId,
            },
            errors: {
                404: `The Customer has not been found`,
            },
        });
    }
    /**
     * Get Customer Multipasses
     * @param customerId
     * @returns MultipassEntity The Customer Multipasses have been returned
     * @throws ApiError
     */
    public customerControllerGetCustomerMultipassesV1(
        customerId: string,
    ): CancelablePromise<Array<MultipassEntity>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/customer/{customerId}/multipasses',
            path: {
                'customerId': customerId,
            },
            errors: {
                404: `The Customer has not been found`,
            },
        });
    }
    /**
     * Get Guests
     * @returns GuestEntity The Guests have been returned
     * @throws ApiError
     */
    public customerControllerGetGuestsV1(): CancelablePromise<Array<GuestEntity>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/customer/guest',
        });
    }
    /**
     * Get Guest
     * @param guestId
     * @param xInstructorIndicator Indicator to scope the request to the instructor
     * @returns GuestEntity The Guest has been returned
     * @throws ApiError
     */
    public customerControllerGetGuestV1(
        guestId: string,
        xInstructorIndicator: string | null = 'true',
    ): CancelablePromise<GuestEntity> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/customer/guest/{guestId}',
            path: {
                'guestId': guestId,
            },
            headers: {
                'x-instructor-indicator': xInstructorIndicator,
            },
            errors: {
                404: `The Guest has not been found`,
            },
        });
    }
    /**
     * Get Guest Orders
     * @param guestId
     * @returns OrderEntity The Guest Orders have been returned
     * @throws ApiError
     */
    public customerControllerGetGuestOrdersV1(
        guestId: string,
    ): CancelablePromise<Array<OrderEntity>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/customer/guest/{guestId}/orders',
            path: {
                'guestId': guestId,
            },
            errors: {
                404: `The Guest has not been found`,
            },
        });
    }
    /**
     * Get Guest Multipasses
     * @param guestId
     * @returns MultipassEntity The Guest Multipasses have been returned
     * @throws ApiError
     */
    public customerControllerGetGuestMultipassesV1(
        guestId: string,
    ): CancelablePromise<Array<MultipassEntity>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/customer/guest/{guestId}/multipasses',
            path: {
                'guestId': guestId,
            },
            errors: {
                404: `The Guest has not been found`,
            },
        });
    }
}
